import { useState, type ComponentProps } from 'react';
import { useDurationInput } from 'react-duration-input';
import { Input } from '@/components/ui/input';

function DurationInput({ defaultValue, className, ...props }: ComponentProps<typeof Input>) {
  const [duration, setDuration] = useState(defaultValue as number * 1000);
  const inputProps = useDurationInput({
    isMilliseconds: false,
    timeInMilliseconds: duration,
    onTimeUpdate: setDuration,
    className,
  });
  return <Input {...props} {...inputProps} />;
}

export default DurationInput;
